<template>
  <form @submit.prevent="submit">
    <div class="row">
      <div class="col-md-6">
        <z-input
          v-model="phoneCell"
          name="phoneCell"
          label="Cell Phone"
          validate="required"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-6">
        <div class="form-group mt-4">
          <input
            type="checkbox"
            id="isAllowTextMessages"
            v-model="isAllowTextMessages"
            class="z-checkbox-small"
            @click="saveIt"
          />
          <label for="isAllowTextMessages" class="custom-allow"
            >allow text messages?</label
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <z-input
          v-model="phoneDay"
          name="phoneDay"
          label="Work Phone"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-6">
        <z-input
          v-model="phoneHome"
          name="phoneHome"
          label="Home Phone"
          @keyup="saveIt"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <z-input
          v-model="address1"
          name="address1"
          label="Address"
          @keyup="saveIt"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <z-input
          v-model="address2"
          name="address2"
          label="Address 2"
          @keyup="saveIt"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <z-input v-model="city" name="city" label="City" @keyup="saveIt" />
      </div>
      <div class="col-md-4">
        <z-select
          v-model="state"
          :options="states"
          label="State"
          @change="changeState"
        />
      </div>
      <div class="col-md-4">
        <z-input
          v-model="zipcode"
          name="zipcode"
          label="Zip Code"
          @keyup="saveIt"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <z-select
          v-model="timezone"
          :options="time_zones"
          label="Timezone"
          @change="changeTimezone"
        />
      </div>
      <div class="col-md-4"></div>
      <div class="col-md-4"></div>
    </div>
  </form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
export default {
  name: 'user-address',
  components: {
    ZInput,
    ZSelect,
  },
  emits: ['saveIt'],
  computed: {
    ...mapGetters('users', ['user']),
    ...mapGetters('configuration', ['stateprovinces', 'timezones']),
    states() {
      let _data = []
      this.stateprovinces.forEach((element) => {
        _data.push({
          name: element.name,
          value: element.name,
        })
      })
      return _data
    },
    time_zones() {
      let _data = []
      this.timezones.forEach((element) => {
        _data.push({
          name: element.name,
          value: element.id,
        })
      })
      return _data
    },
    phoneCell: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.phoneCell
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'phoneCell',
          value: value,
        })
      },
    },
    isAllowTextMessages: {
      get() {
        let _data = false
        if (this.user) {
          _data = this.user.detail.isAllowTextMessages === 1 ? true : false
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'isAllowTextMessages',
          value: value ? 1 : 0,
        })
      },
    },
    phoneHome: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.phoneHome
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'phoneHome',
          value: value,
        })
      },
    },
    phoneDay: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.phoneDay
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'phoneDay',
          value: value,
        })
      },
    },
    address1: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.address1
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'address1',
          value: value,
        })
      },
    },
    address2: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.address2
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'address2',
          value: value,
        })
      },
    },
    city: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.city
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'city',
          value: value,
        })
      },
    },
    state: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.state
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'state',
          value: value,
        })
      },
    },
    zipcode: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.zipcode
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'zipcode',
          value: value,
        })
      },
    },
    timezone: {
      get() {
        let _data = ''
        if (this.user) {
          _data = this.user.detail.timezone_id
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'timezone',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('users', ['setUserData']),
    saveIt() {
      this.$emit('saveIt')
    },
    changeState() {
      this.$emit('saveIt')
    },
    changeTimezone() {
      this.$emit('saveIt')
    },
  },
}
</script>
<style scoped>
.custom-allow {
  margin-left: 5px;
}
</style>
